/* global neonPlayer */
/* global BASE64 */

function WidevineManager() {
    // ---------- Private Fields ---------- //
    var licenseServerUrl = neonPlayer.getSettings().widevineLicenserUrl;
    var _debug = neonPlayer.getSettings().debug;
    var _videojsElement, _videoElement, _licenseData, _kid;
    var serverCertificate = undefined; // Not defined at this point

    // ---------- Private methods ---------- //

    var createSupportedKeySystem = function () {
      var systemOptions = [
        { initDataTypes: ['cenc'],  // cenc = common encryption
            videoCapabilities: [
            {
                contentType: 'video/mp4;codecs="avc1.4D400C"'
            },
            {
                    contentType: 'video/mp4;codecs="avc1.4D400D"'
            },
            {
                contentType: 'video/mp4;codecs="avc1.4D4015"'
            },
            {
                contentType: 'video/mp4;codecs="avc1.4D401E"'
            },
            {
                contentType: 'video/mp4;codecs="avc1.4D401F"'
            }],
            audioCapabilities: [
            {
                ​contentType: 'audio/mp4;codecs="mp4a.40.2"'
            }]
        }];
    
      return navigator.requestMediaKeySystemAccess('com.widevine.alpha', systemOptions).then(
        function(keySystemAccess) {
          return keySystemAccess.createMediaKeys();
        }
      ).catch(function(reason) {
          _videojsElement.error("Unable to instantiate a key system supporting the required combinations. Reason: " + reason)
      });
    };
    
    var onEncrypted = function (event) {
      if(_debug) console.log("Encrypted event fired");
      var video = event.target;
      if (video.mediaKeysObject === undefined) {
        video.mediaKeysObject = null; // Prevent entering this path again.
        video.pendingSessionData = []; // Will store all initData until the MediaKeys is ready.
        createSupportedKeySystem().then(
          function(createdMediaKeys) {
            video.mediaKeysObject = createdMediaKeys;
    
            if (serverCertificate)
              createdMediaKeys.setServerCertificate(serverCertificate);
    
            for (var i = 0; i < video.pendingSessionData.length; i++) {
              var data = video.pendingSessionData[i];
              makeNewRequest(video.mediaKeysObject, data.initDataType, data.initData);
            }
            video.pendingSessionData = [];
    
            return video.setMediaKeys(createdMediaKeys);
          }
        ).catch(function(reason) {
            _videojsElement.error("Failed to create and initialize a MediaKeys object. Reason: " + reason)
        });
      }
      addSession(video, event.initDataType, event.initData);
    }
    
    var addSession = function (video, initDataType, initData) {
      if (video.mediaKeysObject) {
        makeNewRequest(video.mediaKeysObject, initDataType, initData);
      } else {
        video.pendingSessionData.push({initDataType: initDataType, initData: initData});
      }
    }
    
    var makeNewRequest = function (mediaKeys, initDataType, initData) {
      var keySession = mediaKeys.createSession();
      keySession.addEventListener("message", licenseRequestReady, false);
      keySession.generateRequest(initDataType, initData).catch(function(reason) {
          _videojsElement.error("Unable to create or initialize key session. Reason: " + reason)
      });
    }
    
    var licenseRequestReady = function (event) {
      var xmlhttp = new XMLHttpRequest();
      xmlhttp.keySession = event.target;
      xmlhttp.open("POST", licenseServerUrl);
      xmlhttp.onreadystatechange = function() {
        if (xmlhttp.readyState == 4) {
          if(xmlhttp.status != 200 || !xmlhttp.response.license) {
              _videojsElement.error("There was a problem obtaining a proper license for playback (Status code: " + xmlhttp.status + ")");
              return;
          }
          var license = new Uint8Array(BASE64.decodeArray(xmlhttp.response.license));
          xmlhttp.keySession.update(license).catch(function(reason) {
              _videojsElement.error("License update failed. Reason: " + reason)
          });
        }
      }
      
      var laUrl = "";
      laUrl = licenseServerUrl + "/Licenser?kid=" + _kid;
      if (_licenseData.customerToken.length > 0) laUrl = laUrl + "&customerToken=" + _licenseData.customerToken;
      if (_licenseData.deviceToken.length > 0) laUrl = laUrl + "&deviceToken=" + _licenseData.deviceToken;
      
      xmlhttp.open('POST', laUrl);
      xmlhttp.responseType = 'json';
      
      xmlhttp.send(BASE64.encodeArray(new Uint8Array(event.message)));
    }

    // ---------------------- PUBLIC METHODS ---------------------- //
    /**
     * Preparation before license acquisition
     * @param manifest
     * @param callback
     */
    this.prepare = function(manifest, callback) {
        NeonPlayerUtils.getMediaKeyId(manifest, function(kid){
            _kid = kid;
            callback();
        });
    };

    /**
     * Obtains license for video
     * @param videoElement
     * @param licenseData - object that contains custom license data
     */
    this.getLicense = function(context) {
        _videojsElement = context.videojsElement;
        _videoElement = context.videoElement;
        _licenseData = context.licenseData;
        
        _videoElement.addEventListener('encrypted', onEncrypted);
    };
}